import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const WORDS = [
  "CREATE",
  "BUILD",
  "SOLVE",
  "SHARE",
  "ADAPT",
  "MAKE",
  "SHIP",
  "LEARN",
  "SHIFT",
];

const SEP = "✺";

export default function Marquee() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  // Slow editorial drift — one loop, driven by scroll (not autoplay)
  const x = useTransform(scrollYProgress, [0, 1], ["8%", "-38%"]);
  const rowX = useTransform(scrollYProgress, [0, 1], ["-38%", "8%"]);

  return (
    <section
      ref={ref}
      data-testid="marquee-section"
      className="relative bg-white overflow-hidden border-y-2 border-[#1A1A1A]"
    >
      <div className="py-10 md:py-14 space-y-2 md:space-y-4">
        <motion.div
          style={{ x }}
          className="whitespace-nowrap font-display font-black tracking-tighter text-[#1A1A1A]"
        >
          <span className="inline-block text-[14vw] md:text-[10vw] leading-[0.9]">
            {WORDS.map((w, i) => (
              <span key={i} className="mr-8">
                {w}
                <span className="mx-6 text-[#FF007F]">{SEP}</span>
              </span>
            ))}
            {WORDS.map((w, i) => (
              <span key={"b" + i} className="mr-8 text-[#1A1A1A]/20">
                {w}
                <span className="mx-6 text-[#0055FF]">{SEP}</span>
              </span>
            ))}
          </span>
        </motion.div>

        <motion.div
          style={{ x: rowX }}
          className="whitespace-nowrap font-display italic font-black tracking-tight"
        >
          <span className="inline-block text-[7vw] md:text-[4.5vw] leading-[0.95] text-[#4A4A4A]">
            future-ready · not future-ish · future-ready · not future-ish ·
            future-ready · not future-ish · future-ready ·
          </span>
        </motion.div>
      </div>
    </section>
  );
}
